if (!customElements.get('scroll-text-reveal')) {
  class ScrollTextReveal extends HTMLElement {
    constructor() {
      super();
      this.words = [];
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.handleThemeEditor = this.handleThemeEditor.bind(this);
    }

    connectedCallback() {
      this.setupWords();

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.setAllOpacity('1');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', this.onScroll, { passive: true });
              window.addEventListener('resize', this.onScroll, { passive: true });
              this.update();
            } else {
              window.removeEventListener('scroll', this.onScroll);
              window.removeEventListener('resize', this.onScroll);
              const rect = this.getBoundingClientRect();
              const windowHeight = window.innerHeight || document.documentElement.clientHeight;
              if (rect.bottom < 0) {
                this.setAllOpacity('1');
              } else if (rect.top > windowHeight) {
                this.setAllOpacity('0.2');
              }
            }
          });
        },
        { rootMargin: '100px 0px 100px 0px' }
      );

      this.observer.observe(this);

      document.addEventListener('shopify:section:load', this.handleThemeEditor);
      document.addEventListener('shopify:block:select', this.handleThemeEditor);

      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('shopify:section:load', this.handleThemeEditor);
      document.removeEventListener('shopify:block:select', this.handleThemeEditor);
    }

    handleThemeEditor() {
      this.setupWords();
      this.update();
    }

    setupWords() {
      this.words = Array.from(this.querySelectorAll('.scroll-reveal-word'));
      if (this.words.length === 0) {
        const text = this.textContent.trim();
        if (!text) return;
        this.innerHTML = '';
        const words = text.split(/\s+/);
        words.forEach((w, idx) => {
          const span = document.createElement('span');
          span.className = 'scroll-reveal-word';
          span.textContent = w;
          this.appendChild(span);
          if (idx < words.length - 1) {
            this.appendChild(document.createTextNode(' '));
          }
        });
        this.words = Array.from(this.querySelectorAll('.scroll-reveal-word'));
      }
    }

    setAllOpacity(val) {
      for (let i = 0; i < this.words.length; i++) {
        this.words[i].style.opacity = val;
      }
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    update() {
      const total = this.words.length;
      if (!total) return;

      const rect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0) {
        this.setAllOpacity('1');
        return;
      }
      if (rect.top > windowHeight) {
        this.setAllOpacity('0.2');
        return;
      }

      const startY = windowHeight * 0.85;
      const endY = windowHeight * 0.30;

      const totalDistance = Math.max(1, (startY - endY) + rect.height * 0.4);
      const currentDistance = startY - rect.top;

      let progress = currentDistance / totalDistance;
      progress = Math.max(0, Math.min(1, progress));

      for (let i = 0; i < total; i++) {
        const start = i / total;
        const end = Math.min(1, (i + 1.2) / total);

        let wordProgress;
        if (progress <= start) {
          wordProgress = 0;
        } else if (progress >= end) {
          wordProgress = 1;
        } else {
          wordProgress = (progress - start) / (end - start);
        }

        const opacity = 0.2 + 0.8 * wordProgress;
        this.words[i].style.opacity = opacity.toFixed(2);
      }
    }
  }

  customElements.define('scroll-text-reveal', ScrollTextReveal);
}

